import React, { useMemo } from 'react';
import { Box, Typography, Button, Select, MenuItem } from '@mui/material';
import { PictureAsPdf as PictureAsPdfIcon } from '@mui/icons-material';
import { FormatListNumberedIcon } from 'assets/constants/Icons';
import generateQuotationPdf from '../../../lib/generateQuotationPdf';


const OfferDetailsSection = ({ setEnquiry, enquiry, quotationMetadata }) => {
    
    // Auto-calculate final global sum based on items
    const summary = useMemo(() => {
        let totalBuyingCost = 0;
        let baseOfferPrice = 0;
        let designCost = 0;
        let testingCharges = 0;
        let finalOfferPrice = 0;
        let discountedPrice = 0;

        const offerType = enquiry.offerDetails?.offerType;

        (enquiry.items || []).forEach(item => {
            const isSelected = offerType === 'Local Manufacturing'
                ? item.localOffer?.isSelected !== false
                : offerType === 'Imported'
                    ? item.importedOffer?.isSelected !== false
                    : true;

            if (!isSelected) return;

            const pricing = item.pricingDetails || {};
            const qty = Number(item.quantity) || 1;
            
            totalBuyingCost += (Number(pricing.totalBuyingCost) || 0) * qty;
            baseOfferPrice += (Number(pricing.baseOfferPrice) || 0) * qty;
            designCost += (Number(pricing.designCost) || 0) * qty;
            testingCharges += (Number(pricing.testingCharges) || 0) * qty;
            finalOfferPrice += (Number(pricing.finalOfferPrice) || 0) * qty;
            discountedPrice += (Number(pricing.discountedPrice) || 0) * qty;
        });

        let actualMargin = 0;
        if (totalBuyingCost > 0) {
            actualMargin = ((discountedPrice / totalBuyingCost) - 1) * 100;
        }

        return {
            totalBuyingCost: totalBuyingCost.toFixed(2),
            baseOfferPrice: baseOfferPrice.toFixed(2),
            designCost: designCost.toFixed(2),
            testingCharges: testingCharges.toFixed(2),
            finalOfferPrice: finalOfferPrice.toFixed(2),
            discountedPrice: discountedPrice.toFixed(2),
            actualMargin: actualMargin.toFixed(2) + '%'
        };
    }, [enquiry.items, enquiry.offerDetails?.offerType]);

    return (
        <div style={{ padding: '20px' }}>            
        <div className="validation-sub-header">
                <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '100%' }}>
                    <Box sx={{ display: 'flex', alignItems: 'center' }}>
                        <span className="validation-sub-title" style={{  }}>Offer Preparation Stage (Final Aggregated Summary)</span>
                    </Box>
                    <Button 
                        variant="contained" 
                        color="success" 
                        size="medium" 
                        startIcon={<PictureAsPdfIcon />}
                        onClick={() => generateQuotationPdf(enquiry, quotationMetadata)}
                        sx={{
                                textTransform: 'none',
                                fontSize: '14px',
                                fontWeight: 600,
                                backgroundColor: '#2e7d32',
                                color: '#fff !important',
                                '& .MuiButton-startIcon svg': {
                                    color: '#fff'
                                },
                            }}
                    >
                        <span style={{ color: '#fff' }}>Generate Quotation</span>
                    </Button>
                </Box>
            </div>

            {/* <div className="row mt-3">
                {renderFieldRow({
                    label: 'Offer Type',
                    colSpace: 'col-md-6',
                    children: (
                        <Select
                            fullWidth
                            size="small"
                            value={enquiry.offerDetails?.offerType || 'None'}
                            onChange={(e) => {
                                setEnquiry(prev => ({
                                    ...prev,
                                    offerDetails: {
                                        ...prev.offerDetails,
                                        offerType: e.target.value
                                    }
                                }));
                            }}
                            sx={{ background: 'white' }}
                        >
                            <MenuItem value="None">-- Select Offer Strategy --</MenuItem>
                            <MenuItem value="Local Manufacturing">Fixture Local Manufacturing</MenuItem>
                            <MenuItem value="Imported">Fixture/Parts Imported</MenuItem>
                        </Select>
                    )
                })}
            </div> */}

            <Box sx={{ mt: 3, border: '1px solid #e0e0e0', borderRadius: '4px', overflow: 'hidden' }}>
                <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '13px' }}>
                    <thead style={{ backgroundColor: '#fafbfc', color: '#2d3d42', textAlign: 'left' }}>
                        <tr>
                            <th style={{ padding: '10px 16px', borderBottom: '1px solid #e0e0e0', fontWeight: 600 }}>Total Buying Cost</th>
                            <th style={{ padding: '10px 16px', borderBottom: '1px solid #e0e0e0', fontWeight: 600 }}>Base Offer Price</th>
                            <th style={{ padding: '10px 16px', borderBottom: '1px solid #e0e0e0', fontWeight: 600 }}>Design Cost (2%)</th>
                            <th style={{ padding: '10px 16px', borderBottom: '1px solid #e0e0e0', fontWeight: 600 }}>Testing (2%)</th>
                            <th style={{ padding: '10px 16px', borderBottom: '1px solid #e0e0e0', fontWeight: 600 }}>Final Offer Price</th>
                            <th style={{ padding: '10px 16px', borderBottom: '1px solid #e0e0e0', fontWeight: 600 }}>Discounted Price</th>
                            <th style={{ padding: '10px 16px', borderBottom: '1px solid #e0e0e0', fontWeight: 600 }}>Actual Margin</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td style={{ padding: '12px 16px', fontWeight: 'bold', color: '#333' }}>{summary.totalBuyingCost}</td>
                            <td style={{ padding: '12px 16px', fontWeight: 'bold', color: '#333' }}>{summary.baseOfferPrice}</td>
                            <td style={{ padding: '12px 16px', fontWeight: 'bold', color: '#333' }}>{summary.designCost}</td>
                            <td style={{ padding: '12px 16px', fontWeight: 'bold', color: '#333' }}>{summary.testingCharges}</td>
                            <td style={{ padding: '12px 16px', fontWeight: 'bold', color: '#333' }}>{summary.finalOfferPrice}</td>
                            <td style={{ padding: '12px 16px', fontWeight: 'bold', color: '#333' }}>{summary.discountedPrice}</td>
                            <td style={{ padding: '12px 16px', fontWeight: 'bold', color: '#333' }}>{summary.actualMargin}</td>
                        </tr>
                    </tbody>
                </table>
            </Box>
        </div>
    );
};

export default OfferDetailsSection;